import { BaseViewModel } from "../../common/BaseViewModel";
import * as Format from "../../common/FormatFunctions";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import * as ApiService from "../../common/CloudService/ApiService";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as UIMap from "../../common/PrimeComponents";
export class WorkViewModel extends BaseViewModel {
  constructor(updateState, showError, showSuccess, showEmpty) {
    super();
    this.updateState = updateState;
    this.showError = showError;
    this.showSuccess = showSuccess;
    this.showEmpty = showEmpty;
  }

  showLoadingScreen = () => {
    this.updateState("loaded", false);
  };

  hideLoadingScreen = () => {
    this.updateState("loaded", true);
  };

  getStations = async () => {
    var stationResponse = await this.getStationListByCodeTag();
    if (Format.isNotNull(stationResponse.stationList)) {
      this.updateState("stationList", stationResponse.stationList);
      this.logger.info(stationResponse.stationList);
    } else {
      this.showError("Station", CrudlStatus.LIST);
    }
  };

  getStationList = async () => {
    var stationResponse = await this.getStationListByCodeTag();
    if (Format.isNotNull(stationResponse.stationList)) {
      return stationResponse.stationList;
    } else {
      this.showError("Station", CrudlStatus.LIST);
    }
  };

  getStationByKanbanId = async stationId => {
    let stationRequest = new CloudService.StationRequest();
    stationRequest.codeTag = this.codeTag;
    stationRequest.userId = this.userId;
    stationRequest.id = stationId;

    let stationResponse = await ApiService.stationGetByKanbanId(stationRequest);
    if (stationResponse.errorCode === 0) {
      if (Format.isNotNull(stationResponse.kanbanBoardList)) {
        this.logger.info(stationResponse.kanbanBoardList);
        return stationResponse;
      } else {
        this.showError("Station", CrudlStatus.LIST);
      }
    }
  };
  updateWorkItemKanban = async (kanbanBoard, stationId) => {
    let stationRequest = new CloudService.StationRequest();
    stationRequest.codeTag = this.codeTag;
    stationRequest.userId = this.userId;
    stationRequest.kanbanBoard = kanbanBoard;
    stationRequest.id = stationId;

    let stationResponse = await ApiService.stationUpdateByKanban(
      stationRequest
    );
    if (stationResponse.errorCode === 0) {
      return stationResponse;
    } else {
      return stationResponse;
    }
  };

  getStationByCodeTagKanban = async stationId => {
    let stationRequest = new CloudService.StationRequest();
    stationRequest.codeTag = this.codeTag;
    stationRequest.userId = this.userId;

    let stationResponse = await ApiService.stationGetByCodeTagKanban(
      stationRequest
    );
    if (stationResponse.errorCode === 0) {
      if (Format.isNotNull(stationResponse.kanbanBoardList)) {
        this.logger.info(stationResponse.kanbanBoardList);
        return stationResponse.kanbanBoardList[0];
      } else {
        this.showError("Station", CrudlStatus.LIST);
      }
    }
  };
  getCustomers = async () => {
    var customerResponse = await this.getCustomerListByCodeTag();
    if (Format.isNotNull(customerResponse.businesses)) {
      this.updateState("customerList", customerResponse.businesses);
      this.logger.info(customerResponse.businesses);
      var customerArray = UIMap.getDropdownOptionsExtension(
        customerResponse.businesses,
        "businessName",
        "id"
      );
      this.updateState("customerOptions", customerArray);
    } else {
      this.showError("Customer", CrudlStatus.LIST);
    }
  };

  getProducts = async () => {
    var productResponse = await this.getProductListByCodeTag();
    if (Format.isNotNull(productResponse.productList)) {
      this.updateState("productList", productResponse.productList);
      this.logger.info(productResponse.productList);
    } else {
      this.showError("Product", CrudlStatus.LIST);
    }
  };
  getWorks = async () => {
    var workResponse = await this.getWorkListByCodeTag();
    if (Format.isNotNull(workResponse.workList)) {
      workResponse.workList.forEach(async element => {
        element.workItemList = await this.getWorkItemsByWorkId(element.id);
      });
      this.updateState("workList", workResponse.workList);
      this.logger.info(workResponse.workList);
    } else {
      this.showError("Work", CrudlStatus.LIST);
    }
  };
  getWorkItemsByWorkId = async id => {
    var workItemResponse = await this.getWorkItemListByWorkId(id);
    if (Format.isNotNull(workItemResponse.workItemList)) {
      this.logger.info(workItemResponse.workItemList);
      return workItemResponse.workItemList;
    } else {
      return [];
    }
  };

  getParts = async () => {
    var partResponse = await this.getPartListByCodeTag();
    if (Format.isNotNull(partResponse.partList)) {
      this.updateState("partList", partResponse.partList);
      this.logger.info(partResponse.partList);
    } else {
      this.showError("Part", CrudlStatus.LIST);
    }
  };

  getCatalogues = async () => {
    var catalogueResponse = await this.getCatalogueListByCodeTag();
    if (Format.isNotNull(catalogueResponse.catalogueList)) {
      this.updateState("catalogueList", catalogueResponse.catalogueList);
      var catalgoueArray = UIMap.getDropdownOptions(
        catalogueResponse.catalogueList
      );
      this.updateState("catalgoueOptions", catalgoueArray);
      this.logger.info(catalogueResponse.catalogueList);
    } else {
      this.showError("Catalogue", CrudlStatus.LIST);
    }
  };

  getCategorys = async id => {
    var categoryResponse = await this.getCategoryListByCatalogueId(id);
    if (Format.isNotNull(categoryResponse.categoryList)) {
      this.updateState("categoryList", categoryResponse.categoryList);
      this.logger.info(categoryResponse.categoryList);
      var categoryArray = UIMap.getDropdownOptions(
        categoryResponse.categoryList
      );
      this.updateState("categoryOptions", categoryArray);
    } else {
      this.showError("Category", CrudlStatus.LIST);
    }
  };

  reloadDataAfterExecute = (works, apiResponse, type, externalStateValues) => {
    var updatedWorkList = [];
    if (type === CrudlStatus.CREATE) {
      updatedWorkList = this.reloadAfterCreate(
        works,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.UPDATE) {
      updatedWorkList = this.reloadAfterUpdate(
        works,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.DELETE) {
      updatedWorkList = this.reloadAfterDelete(
        works,
        apiResponse,
        externalStateValues
      );
    }

    this.updateState("workList", updatedWorkList);
  };

  reloadAfterCreate = (workList, apiResponse, externalStateValues) => {
    if (workList === undefined || workList === null) {
      workList = [];
    }
    var workBean = externalStateValues.workBean;
    workBean.id = apiResponse.id;
    workBean.lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;

    workList.push(workBean);

    return workList;
  };

  reloadAfterUpdate = (workList, apiResponse, externalStateValues) => {
    var i = 0;
    workList.forEach(e => {
      if (apiResponse.id === e.id) {
        workList[i] = externalStateValues.workBean;
        workList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
      }
      i++;
    });

    return workList;
  };

  reloadAfterDelete = (workList, apiResponse, externalStateValues) => {
    var i = 0;
    workList.forEach(e => {
      //DELETE
      if (apiResponse.id === e.id) {
        workList.splice(i, 1);
      }
      i++;
    });

    return workList;
  };
  executeCRUDLAction = async (crudlStatus, stateVariables) => {
    let workRequest = CloudService.WorkRequest.constructFromObject(
      stateVariables.workBean
    );
    if (crudlStatus === CrudlStatus.CREATE) {
      return await this.createWork(workRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.UPDATE) {
      return await this.updateWork(workRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.DELETE) {
      return await this.deleteWork(workRequest);
    }
  };

  createWork = async (workRequest, stateVariables) => {
    workRequest.codeTag = this.codeTag;
    workRequest.userId = this.userId;

    workRequest.workItemRequestList = this.convertProductsToWorkItemRequests(
      stateVariables.selectedProducts
    );

    let workResponse = await ApiService.workCreate(workRequest);
    if (workResponse.errorCode === 0) {
      this.showSuccess("Work", CrudlStatus.CREATE);
    } else {
      this.showError("Work", CrudlStatus.CREATE);
    }

    return workResponse;
  };

  deleteWork = async workRequest => {
    //RESET PRODUCT REQUEST
    var request = {};
    request.codeTag = this.codeTag;
    request.userId = this.userId;
    request.id = workRequest.id;
    request.lastUpdatedDateTime = workRequest.lastUpdatedDateTime;

    let workResponse = await ApiService.workDelete(request);
    if (workResponse.errorCode === 0) {
      this.showSuccess("Work", CrudlStatus.DELETE);
    } else {
      this.showError("Work", CrudlStatus.DELETE);
    }

    return workResponse;
  };

  updateWork = async (workRequest, stateVariables) => {
    workRequest.codeTag = this.codeTag;
    workRequest.userId = this.userId;

    let workResponse = await ApiService.workUpdate(workRequest);
    if (workResponse.errorCode === 0) {
      this.showSuccess("Work", CrudlStatus.UPDATE);
    } else {
      this.showError("Work", CrudlStatus.UPDATE);
    }

    return workResponse;
  };

  convertProductsToWorkItemRequests = products => {
    var workItemRequestList = [];
    if (Format.isNotNull(products)) {
      products.forEach(element => {
        var workItemRequest = {};
        workItemRequest.productId = element.id;
        workItemRequest.quantity = element.quantity;
        workItemRequest.shipTogether = element.shipTogether;
        workItemRequest.manufactureTogether = element.manufactureTogether;

        workItemRequestList.push(workItemRequest);
      });
    }

    return workItemRequestList;
  };
}



// WEBPACK FOOTER //
// ./src/components/Work/WorkViewModel.js